<template>
  <div class="supplier-auth-token">
    <div>{{ t('supplierAuthTokens.tokenHint') }}</div>
    <div class="token-and-copy-icon">
      <PVInputText :value="token" readonly />
      <FontAwesomeIcon :icon="faCopy" @click="copyToken" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useToast } from '@/composables/useToast';
  import { faCopy } from '@fortawesome/free-regular-svg-icons';
  import { useI18n } from 'vue-i18n';

  const props = defineProps<{
    token: string;
  }>();

  const { t } = useI18n();
  const { createSuccessToast } = useToast();

  function copyToken() {
    navigator.clipboard.writeText(props.token);
    createSuccessToast(t('supplierAuthTokens.tokenCopied'));
  }
</script>

<style scoped lang="scss">
  .supplier-auth-token {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1rem;
    font-size: 1.2rem;
    margin-top: 1rem;

    .token-and-copy-icon {
      display: flex;
      align-items: center;
      column-gap: 1rem;

      svg {
        cursor: pointer;
        color: $link-color;
      }
    }
  }
</style>
